import { Box, Button } from '@mui/material';
import { Link } from 'react-scroll';

export function BottomBanner(): JSX.Element {

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        pointerEvents: 'none', // כדי לא לחסום קליקים על כפתורי WhatsApp וכו'
      }}
    >
      <Link
        to="contact"
        smooth={true}
        duration={600}
        offset={-100}
        style={{ textDecoration: 'none', pointerEvents: 'auto' }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            borderRadius: 99,
            px: 4,
            py: 1.2,
            boxShadow: 3,
            fontSize: '1rem',
          }}
        >
          לחצו כאן להרשמה
        </Button>
      </Link>
    </Box>
  );
}
